<template lang="pug">
b-modal#editAuthority(
  ref="editAuthority"
  :title="$t('ui.combine.edit_authority')"
  centered
  no-fade
  no-close-on-backdrop
  :busy="loading"
  size="xl"
  @ok="done"
  @show="reset"
  @shown="shown"
  @hide="closed"
)
  b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
    div.row.mb-2
      div.col-sm-12.col-md-6.col-lg-6
        b-form-group(:label="$t('ui.login_id')" disabled).mb-0
          b-input-group(size="sm")
            DebounceInput(
              size="sm"
              ref="login_id"
              required
              type="text"
              :dirty="$v.login_id.$dirty"
              :error="$v.login_id.$error"
              v-model.trim.lazy="$v.login_id.$model"
              :disabled="loading"
              :maxLength="$v.login_id.$params.maxLength.max"
            )
          ValidateResult(:value="$v.login_id" :name="$t('ui.login_id')")
    div.row
      div.col-sm-12.col-md-12.col-lg-12
        b-form-group(:label="$t('ui.authority_option')").mb-3
          .row
            //- .col-sm-12.col-md-3.col-lg-3(v-if="isAdmin")
            //-   authorityPanel(category="general" @select-all="rowSelectAll")
            .col-sm-12.col-md-3.col-lg-3
              authorityPanel(category="website" @select-all="rowSelectAll" :updateKey="updateKey")
            .col-sm-12.col-md-3.col-lg-3(v-if="isOperator")
              authorityPanel(category="operation_management" @select-all="rowSelectAll" :updateKey="updateKey")
            .col-sm-12.col-md-3.col-lg-3(v-if="isOperator")
              authorityPanel(category="game_management" @select-all="rowSelectAll" :updateKey="updateKey")
            .col-sm-12.col-md-3.col-lg-3(v-if="isOperator")
              authorityPanel(category="member_management" @select-all="rowSelectAll" :updateKey="updateKey")
            .col-sm-12.col-md-3.col-lg-3(v-if="isOperator")
              authorityPanel(category="promotion_management" @select-all="rowSelectAll" :updateKey="updateKey")
            .col-sm-12.col-md-3.col-lg-3(v-if="!isOperator")
              authorityPanel(category="account" @select-all="rowSelectAll" :updateKey="updateKey")
            .col-sm-12.col-md-3.col-lg-3(v-if="!isOperator")
              authorityPanel(category="operator" @select-all="rowSelectAll" :updateKey="updateKey")
            template(v-if="cpiEnable")
              .col-sm-12.col-md-3.col-lg-3(v-if="getCpiDetails != null || !isOperator")
                authorityPanel(category="cpi" @select-all="rowSelectAll" :updateKey="updateKey")
            .col-sm-12.col-md-3.col-lg-3
              authorityPanel(category="memberreport" @select-all="rowSelectAll" isView=true)
            .col-sm-12.col-md-3.col-lg-3
              authorityPanel(category="ticket" @select-all="rowSelectAll" :updateKey="updateKey")
            .col-sm-12.col-md-3.col-lg-3
              authorityPanel(category="ticketvoucher" @select-all="rowSelectAll" :updateKey="updateKey")
            .col-sm-12.col-md-3.col-lg-3(v-if="!isOperator")
              authorityPanel(category="global" @select-all="rowSelectAll" :updateKey="updateKey")
            .col-sm-12.col-md-3.col-lg-3
              authorityPanel(category="report" @select-all="rowSelectAll" :updateKey="updateKey" isView=true)
            .col-sm-12.col-md-3.col-lg-3
              authorityPanel(category="log" @select-all="rowSelectAll" :updateKey="updateKey" isView=true)
            //- .col-sm-12.col-md-3.col-lg-3(v-if="isOperator")
            //-   authorityPanel(category="risk_management" @select-all="rowSelectAll")
            .col-sm-12.col-md-3.col-lg-3
              authorityPanel(category="affiliate_management" @select-all="rowSelectAll" :updateKey="updateKey")
            .col-sm-12.col-md-3.col-lg-3
              authorityPanel(category="free_credit_provider" @select-all="rowSelectAll" :updateKey="updateKey")
            .col-sm-12.col-md-3.col-lg-3(v-if="isAdmin")
              authorityPanel(category="content" @select-all="rowSelectAll" :updateKey="updateKey")
            .col-sm-12.col-md-3.col-lg-3
              authorityPanel(category="action" @select-all="rowSelectAll" :updateKey="updateKey" isView=true)
            .col-sm-12.col-md-3.col-lg-3
              authorityPanel(category="actionaff" @select-all="rowSelectAll" :updateKey="updateKey" isView=true)

    div.row
      div.col
        b-alert.animated.flash(:show="!feedback.success" variant="bottom") {{ $t("error." + feedback.status) }}
  div(slot="modal-cancel")
    SubmitButton(:loading="loading" icon="fa fa-ban" :text="$t('ui.cancel')" isModal=true)
  div(slot="modal-ok")
    SubmitButton(:loading="loading" icon="fa fa-save" :text="$t('ui.save')" isModal=true)
</template>

<script>
import { required, alphaNum, minLength, maxLength, integer, email, sameAs, helpers } from "vuelidate/lib/validators";
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";
import authority from "@/authority";
import authorityOpr from "@/authorityOpr";
const containAlphaNum = helpers.regex("containAlphaNum", /^(?=.*\d)(?=.*[a-zA-Z])/);
import authorityPanel from "@/components/subAccount/authorityList"; 

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput,
    authorityPanel
  },
  props: {
    item: {
      type: Object
    },
  },
  data() {
    return {
      loading: false,
      feedback: {
        success: true,
        status: ""
      },
      login_id: "",    
      subAccDetail: null,
      // authority_list: authority.list
      authority_list: [],
      updateKey: 0,
      isUat: config.isUat
    };
  },
  computed: {
    isAdmin() {
      return this.$store.getters.accountType === 5;
    },
    isAdminMaster() {
      return [3,5].includes(this.$store.getters.accountType);
    },
    isOperator() {
      return [2].includes(this.$store.getters.accountType);
    },
    operatorID() {
      return this.$store.getters.selectedOperatorID
    },
    filteredAuthorities() {
      return this.authority_list
        .filter(item => item.checked) // Filter only where checked is true
        .map(item => {
          if(!this.isOperator) {
            if(item.value == 'domainop') {
              return ''
            }
          } else {
            if(item.value == 'domainlist' || item.value == 'sitelist') {
              return ''
            }
          }

          if (item.edit) {
            // If both checked and edit are true, combine value and editValue
            return `${item.value},${'e_'+item.value}`;
          } else {
            // If only checked is true, return the value
            return item.value;
          }
        }).filter(item => item != '');
    },
    getCpiDetails() {
      return this.$store.getters.cpiDetails;
    },
    getAuthOriginalChecked() {
      return this.$store.getters.authOriginalChecked;
    },
    cpiEnable() {
      return config.cpiEnable == "1";
    },
    getCurrencyCode() {
      return this.$store.getters.currencyCode;
    },
    fundTransferEnable() {
      return config.fundTransferEnable == "1";
    }
  },
  validations: {
    login_id: {
      required,
      minLength: minLength(6),
      maxLength: maxLength(41)
    }
  },
  methods: {
    rowSelectAll(isSelected, dataList) {
      dataList.forEach(item => {
        item.checked = isSelected;
        item.edit = isSelected;
      });

      this.updateKey = this.updateKey + 1
    },
    done: function(evt) {
      evt.preventDefault();
      this.submit();
    },
    submit: function() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let url = config.accountSubEditUrl();

        var json = {
          action_by: this.$store.getters.loginId,
          auth_token: this.$store.getters.sessionToken,
          login_id: this.item.login_id,
          authority_option: this.filteredAuthorities.join(',') + (this.isOperator ? ',operator,e_operator,settings,operatorsetting' : ''),
          audit_by: this.$store.getters.loginId,
          account_id: this.$store.getters.accountId
        };

        this.feedback.success = true;
        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.loading = false;
            // Success
            try {
              if (response) {
                if (typeof response.data.status == "string") {
                  this.feedback.success = response.data.status == "1";
                } else {
                  this.feedback.success = response.data.status == 1;
                }
                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  this.$emit("clicked");
                  this.$refs.editAuthority.hide();
                } else {
                  this.$helpers.handleFeedback(this.feedback.status);
                  this.$emit("failed", "edit_authority", this.feedback.status);
                  this.$refs.editAuthority.hide();
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        );
      }
    },
    getSubAccDetail() {
      let url = config.accountSubDetailUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        account_id: this.$store.getters.accountId,
        login_id: this.item.login_id
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.subAccDetail = response.data.dt.length > 0 ? response.data.dt[0] : null;
                if (response.data.dt[0].authority_option) {
                  var temp = response.data.dt[0].authority_option.split(",").sort();
                  for(var i = 0; i < temp.length; i++) {
                    this.authority_list = this.authority_list.filter(ele => {
                      if (ele.value == temp[i]) {
                        ele.checked = true
                      }
                      if ("e_" + ele.value == temp[i]) {
                        ele.edit = true
                      }
                      return ele;
                    });
                  }
                }
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    reset: function() {
      this.feedback.success = true;
      this.feedback.status = "";
    },
    shown: function() {
      this.$v.$reset();
      this.login_id = this.item.login_id;
      this.authority_list = this.isOperator ? authorityOpr.list : authority.list;

      if(this.isUat == 'false') {
        if(!['BDT'].includes(this.getCurrencyCode)) {
          this.authority_list = this.authority_list.filter(d => { return d.value != 'pendingbetlist9w' })
        } else {
          this.authority_list = this.authority_list.filter(d => { return d.value != 'pendingbetlistothers' })
        }
        if(!this.fundTransferEnable) {
          this.authority_list = this.authority_list.filter(d => { return d.value != 'ftprovider' })
        }
      }

      if(!this.isAdmin) {
        this.authority_list = this.authority_list.filter(d => { return d.value != 'clearoutstandinglog'})
      }

      const checkedMap = new Map(
        this.getAuthOriginalChecked.map(item => [item.value, item])
      );

      this.authority_list.forEach(item => {
        // try to find a matching checked item in the Map
        const match = checkedMap.get(item.value);

        if (match) {
          item.checked = match.checked;
          item.edit = match.edit;
        } else {
          item.checked = false;
          item.edit = false;
        }
      });
      this.getSubAccDetail();
    },
    closed: function() {
      this.login_id = "";
      this.authority_list.map(function(x) {
        x.checked = false;
        x.edit = false;
        return x;
      });
    }
  }
};
</script>
